import { render, staticRenderFns } from "./CongestionFilters.vue?vue&type=template&id=1c568d68&scoped=true&"
import script from "./CongestionFilters.vue?vue&type=script&lang=js&"
export * from "./CongestionFilters.vue?vue&type=script&lang=js&"
import style0 from "./CongestionFilters.vue?vue&type=style&index=0&id=1c568d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c568d68",
  null
  
)

export default component.exports